module.exports = __webpack_public_path__ + "static/media/microsite_app_icon_new.be6f0a48.svg";